import './Schedule.scss';
import React, { useState } from 'react';
import moment from 'moment';
import useGoogleAPI from '../../hooks/gapi';
import 'moment/locale/ru';
import Calendar from '../Calendar/Calendar';

import { ReactComponent as ChevronLeft } from '../../assets/img/chevron-left.svg';
import { weekFirstDay, weekLastDay } from '../../helpers/dates';
import EventPopup from '../EventPopup/EventPopup';

moment.locale('ru');

const createWeekRow = (fn) => Array.from({ length: 7 }, fn);

const getEventsForWeek = (week, events) => {
  const firstDayWeek = weekFirstDay(week);
  const dates = createWeekRow((val, index) => moment(firstDayWeek).add(index, 'd'));

  return dates.reduce((acc, date) => {
    const dayEvents = events.filter(({ start }) => date.isSame(start, 'day'));
    acc[date.format('YYYY-MM-DD')] = dayEvents.length ? dayEvents : [{
      id: null,
      title: 'Сегодня событий нет',
    }];
    return acc;
  }, {});
};

const Schedule = () => {
  const [currentWeek, setCurrentWeek] = useState(moment().week());
  const [isShowEventPopup, setIsShowEventPopup] = useState(false);
  const [currentEventId, setCurrentEventId] = useState(null);

  const showEventPopup = (eventId) => {
    setIsShowEventPopup(true);
    setCurrentEventId(eventId);
  };

  const firstDayWeek = weekFirstDay(currentWeek);
  const lastDayWeek = weekLastDay(currentWeek);

  const { isLoading, events, getEvents } = useGoogleAPI(firstDayWeek, lastDayWeek);

  const changeWeek = (newWeek) => {
    setCurrentWeek(newWeek);
    getEvents(weekFirstDay(newWeek), weekLastDay(newWeek));
  };

  const currentEvent = events.find((item) => item.id === currentEventId);

  return (
    <div className="xti-schedule">
      <div className="xti-schedule__week-spinner">
        <button className="xti-schedule__prev-week-btn" type="button" onClick={() => changeWeek(currentWeek - 1)}>
          <ChevronLeft />
        </button>
        { firstDayWeek.date() } - { lastDayWeek.format('D MMMM') }
        <button className="xti-schedule__next-week-btn" type="button" onClick={() => changeWeek(currentWeek + 1)}>
          <ChevronLeft />
        </button>
      </div>
      <Calendar week={currentWeek} events={getEventsForWeek(currentWeek, events)} isLoading={isLoading} onClickCell={showEventPopup} />
      { isShowEventPopup && currentEvent && <EventPopup event={currentEvent} onClose={() => setIsShowEventPopup(false)} /> }
    </div>
  );
};

export default Schedule;
